<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 500px; max-width: 80vw;':''">
    <q-card-section class="row items-center q-pb-none">
      <div>
        <div class="text-bold">{{ Customer.Cs_Name }}</div>
        <div class="row q-ml-xs">
          <q-badge color="deep-orange-14"><i>شناسه(</i><b>{{ Customer.Cs_Code }}</b><i>)</i>
          </q-badge>
        </div>
      </div>
      <q-space/>
      <q-btn icon="close" flat round dense v-close-popup/>
    </q-card-section>

    <q-card-section class="no-padding q-mt-sm">
      <q-btn round
             flat
             icon="add_circle"
             padding="none"
             size="lg"
             color="indigo"
             @click="showGoodsGroupCuDialog({Group_ID:undefined,Group_Name:undefined})"
             v-if="$store.state.roles.some(v=>['admin','can_manage_goods_group'].includes(v))">
        <q-tooltip>
          افزودن گروه جدید
        </q-tooltip>
      </q-btn>
      <q-expansion-item
          class="shadow-1 overflow-hidden"
          icon="explore"
          label="گروه کالا و کالاهای مورد نیاز طرف معامله"
          header-class="bg-indigo text-white"
          expand-icon-class="text-white"
          style="border-radius: 10px"
          default-opened
      >
        <q-form @submit="onSubmit">
          <q-card>
            <q-card-section>
              <q-select
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  v-model="selectedGoodsGroup"
                  use-input
                  input-debounce="0"
                  label="گروه کالا"
                  :options="goodsGroupListOptions"
                  @filter="filterFnGoodsGroup"
                  behavior="dialog"
                  option-label="Group_Name"
                  multiple
                  use-chips
                  option-value="Group_ID"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      بدون نتیجه
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
              <q-select
                  :dense="$q.screen.lt.md"
                  class="q-ma-xs"
                  filled
                  v-model="selectedGoodsList"
                  use-input
                  input-debounce="0"
                  label="کالا"
                  :options="goodsListOptions"
                  @filter="filterFnGoods"
                  behavior="dialog"
                  option-label="Goods_Name"
                  multiple
                  use-chips
                  option-value="Goods_ID"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      بدون نتیجه
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </q-card-section>
            <q-card-actions align="center">
              <q-btn type="submit" color="indigo" icon="check" text-color="white" label="ثبت کالاها و گروه کالاها"/>
            </q-card-actions>
          </q-card>
        </q-form>
      </q-expansion-item>
    </q-card-section>
    <q-card-section class="no-padding q-mt-sm">
      <q-expansion-item
          class="shadow-1 overflow-hidden"
          icon="explore"
          label="گروه کالاهای فعال بر اساس فعالیت گذشته"
          header-class="bg-indigo text-white"
          expand-icon-class="text-white"
          style="border-radius: 10px"
      >
        <q-table
            :data="OrderGoodsGroupList"
            row-key="CS_ID"
            wrap-cells
            hide-header
            flat
            :pagination="pagination">
          <template v-slot:body="props">
            <q-tr :props="props" class="my-class">
              <q-td>
                <q-card flat>
                  <q-card-section class="no-padding">
                    <div class="row">
                      <div class="col-xs-12">
                        <div class="row">
                          <div class="col">
                            <span>{{ props.row.Group_Name }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <q-chip :size="$q.screen.lt.md?'md':'md'" color="purple" text-color="white" square
                                  icon="shopping_cart">
                            تعداد {{ props.row.SaleG_Count }}
                          </q-chip>
                          <q-chip :size="$q.screen.lt.md?'md':'md'" color="purple-10" text-color="white" square
                                  icon="score">
                            درصد {{ props.row.SaleG_Perc.toFixed(2) }}
                          </q-chip>
                        </div>
                      </div>
                    </div>
                  </q-card-section>
                </q-card>
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </q-expansion-item>
    </q-card-section>

    <q-card-section class="no-padding q-mt-sm">
      <q-expansion-item
          class="shadow-1 overflow-hidden"
          icon="explore"
          label="کالاهای پرمصرف بر اساس فعالیت گذشته"
          header-class="bg-indigo text-white"
          expand-icon-class="text-white"
          style="border-radius: 10px"
      >
        <q-table
            :data="OrderGoodsList"
            row-key="CS_ID"
            wrap-cells
            hide-header
            flat
            :pagination="pagination">
          <template v-slot:body="props">
            <q-tr :props="props" class="my-class">
              <q-td>
                <q-card flat>
                  <q-card-section class="no-padding">
                    <div class="row">
                      <div class="col-xs-12">
                        <div class="row">
                          <div class="col">
                            <span>{{ props.row.Goods_Name }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <q-chip :size="$q.screen.lt.md?'md':'md'" color="purple" text-color="white" square
                                  icon="shopping_cart">
                            تعداد {{ props.row.SaleG_Count }}
                          </q-chip>
                          <q-chip :size="$q.screen.lt.md?'md':'md'" color="purple-10" text-color="white" square
                                  icon="score">
                            درصد {{ props.row.SaleG_Perc.toFixed(2) }}
                          </q-chip>
                        </div>
                      </div>
                    </div>
                  </q-card-section>
                </q-card>
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </q-expansion-item>
    </q-card-section>
    <q-dialog v-model="goodsGroupCUDialog" :maximized="$q.screen.lt.md">
      <GoodsGroup :goods-group-info="selectedGroup" @changed-goods-group="changedGoodsGroup"/>
    </q-dialog>

  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import GoodsGroup from "@/components/GoodsGroup/GoodsGroup.vue";

export default {
  name: "GoodsGroupReports",
  components: {GoodsGroup},
  props: ['OrderGoodsGroupList', 'OrderGoodsList', 'Customer'],
  data() {
    return {
      goodsGroupList: [],
      goodsGroupListOptions: [],
      goodsList: [],
      goodsListOptions: [],
      selectedGoodsGroup: null,
      selectedGoodsList: null,
      pagination: {
        rowsPerPage: 10
      },
      goodsGroupCUDialog: false,
      selectedGroup: undefined
    }
  },
  methods: {
    ...mapActions({
      getGoodsGroup: 'Products/getSimpleGoodsGroupList',
      getGoodsList: 'Products/getGoodsList',
      getCustomerInfo: 'Customers/get_customer_info',
      updateCustomerGoodsInfo: 'Customers/updateCustomerGoodsInfo',
      addGroup: 'Products/addGoodsGroup'
    }),
    showGoodsGroupCuDialog(args) {
      this.selectedGroup = args
      this.goodsGroupCUDialog = true
    },
    setGoodsGroup: function () {
      this.getGoodsGroup().then((res) => {
        this.goodsGroupList = res;
        this.goodsGroupListOptions = this.goodsGroupList;

        this.getCustomerInfo(this.Customer.Cs_ID).then((res) => {
          this.selectedGoodsGroup = eval(res.data[0].Goods_Group)
          this.selectedGoodsList = eval(res.data[0].Goods)
        })
      })
    },
    filterFnGoodsGroup(val, update) {
      if (val === '') {
        update(() => {
          this.goodsGroupListOptions = this.goodsGroupList
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.goodsGroupListOptions = this.goodsGroupList.filter(v => v.Group_Name && v.Group_Name.toLowerCase().indexOf(needle) > -1)
      })
    },
    filterFnGoods(val, update) {
      if (val === '') {
        update(() => {
          this.goodsListOptions = this.goodsList
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.goodsListOptions = this.goodsList.filter(v => v.Goods_Name.toLowerCase().indexOf(needle) > -1)
      })
    },
    onSubmit() {
      this.updateCustomerGoodsInfo({
        cs_id: this.Customer.Cs_ID,
        goods: this.selectedGoodsList,
        goodsGroup: this.selectedGoodsGroup
      }).then(() => {
        this.Customer.goods = this.selectedGoodsList
        this.Customer.goodsGroup = this.selectedGoodsGroup
        this.$q.notify({
          message: 'گروه های کالا و کالاهای انتخابی برای طرف معامله به ثبت رسید',
          type: 'positive',
          color: 'positive',
          position: 'center'
        })
      })
    },
    changedGoodsGroup(args) {
      if (args.Group_ID === undefined) {
        this.addGroup(args).then((res) => {
          this.goodsGroupList.push(res[0])
          this.goodsGroupListOptions.push(res[0])
          this.$q.notify({
            message: 'گروه کالا اضافه شد',
            type: 'positive',
            color: 'positive',
            icon: 'positive',
            position: 'top'
          })
        })
        this.goodsGroupCUDialog = false
      }
    },
  },
  watch: {
    selectedGoodsGroup: function (newValue) {
      this.getGoodsList({
        goodsGroup: newValue,
        selectedStore: []
      }).then((res) => {
        this.goodsList = res
        this.goodsListOptions = this.goodsList
      })
    }
  },
  created() {
    this.setGoodsGroup();
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}
</style>
